import { RouteRecordRaw } from 'vue-router'

const editAudienceRoute: RouteRecordRaw = {
  name: 'editAudience',
  path: 'audience/:audienceId/edit',
  component: () => import('./EditAudience.vue'),
  meta: {
    requireAuth: true,
    title: 'Edit Audience'
  }
}

export default editAudienceRoute
